// @flow
import React, {PureComponent} from 'react'
import classnames from 'classnames'

type Props = {
  message: string,
  className: string,
  handleClose: Function,
}

export class Notification extends PureComponent<Props> {

  render() {
    const {message, className, handleClose} = this.props
    
    const notiCls = classnames('notification', className)
    return (
      <div className={notiCls}>
        <span className="delete" onClick={handleClose}>
          <i className="fas fa-times-circle"></i>
        </span>
        <p>{message}</p>
      </div>
    )
  }
}